// Types of things that can be updated

import { allCases } from '../typescriptHelpers';

//TODO: in the future this should contain a lot of the updatables that are in the release updatable
export enum ReleaseStepUpdatable {
    //FR items updatables
    IgnoreFRItem = 'TRY_IGNORE_FR_ITEM',
    UnignoreFRItem = 'TRY_UNIGNORE_FR_ITEM',
    AddFixRequest = 'TRY_ADD_FIX_REQUEST',
    UpdateFixRequest = 'TRY_UPDATE_FIX_REQUEST',
    ApproveFixRequest = 'TRY_APPROVE_FIX_REQUEST',
    RejectFixRequest = 'TRY_REJECT_FIX_REQUEST',
    MoveFixRequestToPendingApproval = 'TRY_MOVE_FIX_REQUEST_TO_PENDING_APPROVAL',
    GetPendingAssociationFixRequests = 'TRY_GET_PENDING_ASSOCIATION_FIX_REQUESTS',

    // Translation updatables
    UploadTranslationStrings = 'TRY_UPLOAD_TRANSLATION_STRINGS',
    ExportTranslationStrings = 'TRY_EXPORT_TRANSLATION_STRINGS',
    SyncTranslationStrings = 'TRY_SYNC_TRANSLATION_STRINGS',
    TranslationsApproval = 'TRY_UPDATE_TRANSLATIONS_APPROVAL',
}

export const AllReleaseStepUpdatableTypes = allCases(ReleaseStepUpdatable);

// Features of the release that can be updated
export enum ReleaseUpdatable {
    RegressionStatus = 'TRY_UPDATE_REGRESSION_STATUS',
    ScreenshotsApproval = 'TRY_UPDATE_SCREENSHOTS_APPROVAL',
    MetadataApproval = 'TRY_UPDATE_METADATA_APPROVAL',
    EndBetaSoak = 'TRY_END_BETA_SOAK',
    TagRelease = 'TRY_TAG_RELEASE',
    UpdateReleaseTag = 'TRY_UPDATE_RELEASE_TAG',
    UpdateReleaseNotes = 'TRY_UPDATE_RELEASE_NOTES',
    UpdatePlanningSummary = 'TRY_UPDATE_PLANNING_SUMMARY',
    UpdateSelectedBuild = 'TRY_UPDATE_SELECTED_BUILD',
    UpdateAdditionalSelectedBuilds = 'TRY_UPDATE_ADDITIONAL_SELECTED_BUILDS',
    UpdateAppleAppStoreSettings = 'TRY_UPDATE_APPLE_APPSTORE_SETTINGS',
    UpdateGoogleReleaseSettings = 'TRY_UPDATE_GOOGLE_RELEASE_SETTINGS',
    UpdateHuaweiReleaseSettings = 'TRY_UPDATE_HUAWEI_RELEASE_SETTINGS',
    SubmitAppForReview = 'TRY_SUBMIT_FOR_REVIEW',
    HaltGooglePhasedRelease = 'TRY_HALT_GOOGLE_PHASED_RELEASE',
    UpdateGooglePhasedRelease = 'TRY_UPDATE_GOOGLE_PHASED_RELEASE',
    CompleteGooglePhasedRelease = 'TRY_COMPLETE_GOOGLE_PHASED_RELEASE',
    StartAutomatedStagedRollout = 'TRY_START_AUTOMATED_ROLLOUT',
    PauseApplePhasedRelease = 'TRY_PAUSE_APPLE_PHASED_RELEASE',
    ResumeApplePhasedRelease = 'TRY_RESUME_APPLE_PHASED_RELEASE',
    CompleteApplePhasedRelease = 'TRY_COMPLETE_APPLE_PHASED_RELEASE',
    PauseHuaweiPhasedRelease = 'TRY_PAUSE_HUAWEI_PHASED_RELEASE',
    UpdateHuaweiPhasedRelease = 'TRY_RESUME_HUAWEI_PHASED_RELEASE',
    CompleteHuaweiPhasedRelease = 'TRY_COMPLETE_HUAWEI_PHASED_RELEASE',
    RejectAppleSubmission = 'TRY_REJECT_APPLE_SUBMISSION',
    ReleaseAppleVersion = 'TRY_RELEASE_APPLE_VERSION',
    CreateReleaseBranch = 'TRY_CREATE_RELEASE_BRANCH',
    PromoteWorkingBranch = 'TRY_PROMOTE_WORKING_BRANCH',
    BumpVersion = 'TRY_BUMP_VERSION',
    SelectReleaseCandidateBuild = 'TRY_SELECT_RC_BUILD',
    ResumeAutoSelectingLatestReleaseCandidateBuild = 'TRY_RESUME_AUTOSELECT_LATEST_RC_BUILD',
    AddBetaBuildLocalizedNotes = 'TRY_ADD_BETA_LOCALIZATION_NOTES',
    UpdateBetaBuildLocalization = 'TRY_UPDATE_BETA_LOCALIZATION',
    UpdateMultiLocaleTestingNotes = 'TRY_UPDATE_MULTI_LOCALE_TESTING_NOTES',
    AddIndividualTesterToBuild = 'TRY_ADD_INDIVIDUAL_TESTER_TO_BUILD',
    AddBetaGroupsToBuild = 'TRY_ADD_BETA_GROUPS_TO_BUILD',
    SubmitBetaBuildForReview = 'TRY_SUBMIT_BETA_BUILD_FOR_REVIEW',
    PromoteActiveBuildToTestingTrack = 'TRY_PROMOTE_ACTIVE_BUILD_TO_TESTING_TRACK',
    PromoteBuildToTestingTrack = 'TRY_PROMOTE_BUILD_TO_TESTING_TRACK',
    PauseScheduleCadence = 'TRY_PAUSE_SCHEDULE_CADENCE',
    ResumeScheduleCadence = 'TRY_RESUME_SCHEDULE_CADENCE',
    DeleteScreenshot = 'TRY_DELETE_SCREENSHOT',
    DeleteAppPreview = 'TRY_DELETE_APP_PREVIEW',
    MarkReleaseRejected = 'TRY_MARK_ANDROID_RELEASE_REJECTED',
    RetryAppStoreArtifactUpload = 'TRY_RETRY_APP_STORE_ARTIFACT_UPLOAD',
    RetryDsymUpload = 'TRY_RETRY_DSYM_UPLOAD',
    MarkReleaseSkipped = 'TRY_MARK_RELEASE_SKIPPED',
    MarkReleaseComplete = 'TRY_MARK_RELEASE_COMPLETE',
    MarkReleaseUncomplete = 'TRY_MARK_RELEASE_UNCOMPLETE',
    MarkReleaseUnskipped = 'TRY_MARK_RELEASE_UNSKIPPED',
    TryStartResignSequence = 'TRY_START_RESIGN_SEQUENCE',
    CustomizeReleaseSummaryMessage = 'TRY_CUSTOMIZE_RELEASE_SUMMARY_MESSAGE',
    UpdateReviewDetails = 'TRY_UPDATE_REVIEW_DETAILS',
    AddReviewSubmissionItem = 'TRY_ADD_REVIEW_SUBMISSION_ITEM',
    RemoveReviewSubmissionItem = 'TRY_REMOVE_REVIEW_SUBMISSION_ITEM',
    UnblockReleaseReviewSubmission = 'TRY_UNBLOCK_RELEASE_REVIEW_SUBMISSION',
    CancelReleaseReviewSubmission = 'TRY_CANCEL_RELEASE_REVIEW_SUBMISSION',
    UploadMetadataForTranslation = 'TRY_UPLOAD_METADATA_FOR_TRANSLATION',
    ExportMetadataTranslations = 'TRY_EXPORT_METADATA_FOR_TRANSLATION',
    SyncMetadataTranslations = 'TRY_SYNC_METADATA_FOR_TRANSLATION',
}

export enum FeatureFlagUpdatable {
    ToggleFeatureFlag = 'TRY_TOGGLE_FEATURE_FLAG',
}

export const AllFeatureFlagUpdatableTypes = allCases(FeatureFlagUpdatable);

export const AllReleaseUpdatableTypes = allCases(ReleaseUpdatable);

export enum ChecklistItemUpdatable {
    ChecklistItemStatusChanged = 'TRY_CHECKLIST_ITEM_STATUS_CHANGED',
    ChecklistItemCommentChanged = 'TRY_CHECKLIST_ITEM_COMMENT_CHANGED',
}

export const AllChecklistItemUpdatableTypes = allCases(ChecklistItemUpdatable);

export enum AppSettingsUpdatable {
    NewFeatureAffiliation = 'TRY_NEW_FEATURE_AFFILIATION',
    DeleteFeatureAffiliation = 'DELETE_FEATURE_AFFILIATION',
    UpdateFeatureAffiliation = 'UPDATE_FEATURE_AFFILIATION',
    NewReleaseBranchPattern = 'TRY_NEW_RELEASE_BRANCH_PATTERN',
    UpdateReleaseBranchPattern = 'UPDATE_RELEASE_BRANCH_PATTERN',
    DeleteReleaseBranchPattern = 'DELETE_RELEASE_BRANCH_PATTERN',
    NewReleaseTagPattern = 'TRY_NEW_RELEASE_TAG_PATTERN',
    UpdateReleaseTagPattern = 'UPDATE_RELEASE_TAG_PATTERN',
    DeleteReleaseTagPattern = 'DELETE_RELEASE_TAG_PATTERN',
    BetaStyle = 'TRY_UPDATE_BETA_STYLE',
    RegressionTestingStrategy = 'TRY_UPDATE_REGRESSION_TESTING_STRATEGY',
    SetAdditionalBranches = 'TRY_SET_ADDITIONAL_BRANCHES',
    UpdateAppleAppStoreReleaseDefaults = 'TRY_UPDATE_APPLE_APP_STORE_DEFAULTS',
    UpdatePlayAppStoreReleaseDefaults = 'TRY_UPDATE_PLAY_APP_STORE_DEFAULTS',
    UpdateAppGalleryAppStoreReleaseDefaults = 'TRY_UPDATE_APPGALLERY_APP_STORE_DEFAULTS',
    UpdateAppStoreDefaultReleaseNotes = 'TRY_UPDATE_DEFAULT_RELEASE_NOTES',
    UpdateReleaseScheduleCadenceSettings = 'TRY_UPDATE_RELEASE_SCHEDULE_CADENCE_SETTINGS',
    UpdateReleasePilotList = 'TRY_UPDATE_RELEASE_PILOT_LIST',
    RemoveReleasePilot = 'TRY_REMOVE_RELEASE_PILOT',
    UpdateVersioningDefaults = 'TRY_UPDATE_VERSIONING_DEFAULTS',
    UpdateNotificationSetting = 'TRY_UPDATE_NOTIFICATION_SETTING',
    UpdateBumpVersionOverrideFiles = 'TRY_UPDATE_BUMP_VERSION_OVERRIDE_FILES',
    UpdateTranslationDirectories = 'TRY_UPDATE_TRANSLATION_DIRECTORIES',
    UpdateNonBlockingSteps = 'TRY_UPDATE_NON_BLOCKING_RELEASE_STEPS',
    TagCommit = 'TRY_TAG_COMMIT',
    UploadDefaultReviewAttachment = 'TRY_UPLOAD_DEFAULT_REVIEW_ATTACHMENT',
    RemoveDefaultReviewAttachment = 'TRY_REMOVE_DEFAULT_REVIEW_ATTACHMENT',
    UpdateFilterPaths = 'TRY_UPDATE_FILTER_PATHS',
    UpdateUserRolesMap = 'TRY_UPDATE_USER_ROLES_MAP',
    TriggerIntegrationRefresh = 'TRY_TRIGGER_INTEGRATION_REFRESH',
    AddMonitoringMetric = 'TRY_ADD_MONITORING_METRIC',
    UpdateMonitoringMetric = 'TRY_UPDATE_MONITORING_METRIC',
    DeleteMonitoringMetric = 'TRY_DELETE_MONITORING_METRIC',
    UpdateQualitativeOnboardingStatus = 'TRY_UPDATE_QUALITATIVE_ONBOARDING_STATUS',
    UpdateReleasePilotsOrder = 'TRY_UPDATE_RELEASE_PILOTS_ORDER',
    UpdateSigningKey = 'TRY_UPDATE_SIGNING_KEY',
    DeleteSigningKey = 'TRY_DELETE_SIGNING_KEY',
    RequiresFixRequestsApprovals = 'TRY_UPDATE_REQUIRES_FIX_REQUESTS_APPROVALS',
    UpdateBundleSizeDeviceModel = 'TRY_UPDATE_BUNDLE_SIZE_DEVICE_MODEL',
}

export const AllAppSettingsUpdatableTypes = allCases(AppSettingsUpdatable);

// This v2 is for things that affect app settings AND a release, the response will contain both
export enum AppSettingsV2Updatable {
    NewChecklistItem = 'TRY_NEW_CHECKLIST_ITEM',
    UpdateReleaseStepChecklistItem = 'UPDATE_RELEASE_STEP_CHECKLIST_ITEM',
    DeleteReleaseStepChecklistItem = 'DELETE_RELEASE_STEP_CHECKLIST_ITEM',
    UpdateReleaseStepChecklistItemOrder = 'UPDATE_RELEASE_STEP_CHECKLIST_ITEM_ORDER',
    AddAppUsers = 'ADD_APP_USERS',
    RemoveAppUsers = 'REMOVE_APP_USERS',
    EnableBuildDistro = 'TRY_ENABLE_BUILD_DISTRO',
    UpdateAutomationSettings = 'TRY_UPDATE_AUTOMATION_SETTINGS',
    UpdateCustomMessagesTemplates = 'UPDATE_CUSTOM_MESSAGES_TEMPLATES',
    RefreshIntegrationRefreshData = 'TRY_REFRESH_INTEGRATION_REFRESH_DATA',
    UpdateStepNotificationConfig = 'TRY_UPDATE_STEP_NOTIFICATION_CONFIG',
    DeleteStepNotificationConfig = 'TRY_DELETE_STEP_NOTIFICATION_CONFIG',
}

export const AllAppSettingsV2UpdatableTypes = allCases(AppSettingsV2Updatable);

export enum DestinationUpdatable {
    UpdateDestinationDetails = 'TRY_UPDATE_DESTINATION_DETAILS',
}

export const AllDestinationUpdatableTypes = allCases(DestinationUpdatable);

export enum OrgSettingsUpdatable {
    MergeAccountsSetting = 'TRY_UPDATE_MERGE_ACCOUNTS_SETTING',
    UpdateUser = 'TRY_UPDATE_USER',
    RemoveOrgUser = 'TRY_DELETE_ORG_USER',
    NewWebhookEndpoint = 'TRY_NEW_ORG_WEBHOOK',
    UpdateWebhookEndpoint = 'TRY_UPDATE_ORG_WEBHOOK',
    DeleteWebhookEndpoint = 'TRY_DELETE_ORG_WEBHOOK',
    UpdateAddNewUsersToAppsSetting = 'TRY_UPDATE_ADD_NEW_USERS_TO_APPS_SETTING',
    DeletePublicApiKeyEndpoint = 'TRY_DELETE_PUBLIC_API_KEY',
    UpdateUserGroupsForDirectorySyncGroup = 'TRY_UPDATE_USER_ROLES_FOR_DIRECTORY_SYNC_GROUP',
    RemoveDeviceFromOrgUser = 'TRY_REMOVE_DEVICE_FROM_ORG_USER',
    UpdateVCSUserNameForOrgUser = 'TRY_UPDATE_VCS_USER_NAME_FOR_ORG_USER',
    UpdateTimezonePreferenceForOrgUser = 'TRY_UPDATE_TIMEZONE_PREFERENCE_FOR_ORG_USER',
    CreateCustomGroup = 'TRY_CREATE_CUSTOM_GROUP',
    UpdateCustomGroup = 'TRY_UPDATE_CUSTOM_GROUP',
    DeleteCustomGroup = 'TRY_DELETE_CUSTOM_GROUP',
    UpdateProviderIdToUserGroupsToCommsGroupsMap = 'TRY_UPDATE_PROVIDER_ID_TO_USER_ROLES_TO_COMMS_GROUPS_MAP',
    ActivateTrial = 'TRY_ACTIVATE_TRIAL',
    UpdateOrgTimezone = 'TRY_UPDATE_ORG_TIMEZONE',
    UpdateAISettings = 'TRY_UPDATE_AI_SETTINGS',
    UpdateIntegrationProviderName = 'TRY_UPDATE_INTEGRATION_PROVIDER_NAME',
}

export const AllOrgSettingsUpdatableTypes = allCases(OrgSettingsUpdatable);

export enum PublicApiUpdatable {
    NewPublicApiKeyEndpoint = 'TRY_NEW_ORG_PUBLIC_API_KEY',
}

export const AllPublicApiUpdatableTypes = allCases(PublicApiUpdatable);

export enum AuthUpdatable {
    SlackAccess = 'TRY_SLACK_ACCESS',
    BitbucketAccess = 'TRY_BITBUCKET_ACCESS',
    BitbucketCIAccess = 'TRY_BITBUCKET_CI_ACCESS',
    GitHubVCSAccess = 'TRY_GITHUB_VCS_ACCESS',
    GitHubVCSDistAccess = 'TRY_GITHUB_VCS_DIST_ACCESS',
    GitHubCIAccess = 'TRY_GITHUB_CI_ACCESS',
    GitHubITAccess = 'TRY_GITHUB_IT_ACCESS',
    GitHubCIDistAccess = 'TRY_GITHUB_CI_DIST_ACCESS',
    GitLabVCSAccess = 'TRY_GITLAB_VCS_ACCESS',
    GitLabCIAccess = 'TRY_GITLAB_CI_ACCESS',
    JiraAccess = 'TRY_JIRA_ACCESS',
    PivotalAccess = 'TRY_PIVOTAL_ACCESS',
    CodemagicAccess = 'TRY_CODEMAGIC_ACCESS',
    BitriseAccess = 'TRY_BITRISE_ACCESS',
    BuildkiteAccess = 'TRY_BUILDKITE_ACCESS',
    BugsnagAccess = 'TRY_BUGSNAG_ACCESS',
    SentryAccess = 'TRY_SENTRY_ACCESS',
    AppStoreConnectAccess = 'TRY_ASC_ACCESS',
    JenkinsAccess = 'TRY_JENKINS_ACCESS',
    CircleAccess = 'TRY_CIRCLE_ACCESS',
    GooglePlayAccess = 'TRY_GOOGLE_PLAY_ACCESS',
    AmazonAppStoreAccess = 'TRY_AMAZON_APP_STORE_ACCESS',
    LinearAccess = 'TRY_LINEAR_ACCESS',
    TestFlightAccess = 'TRY_TESTFLIGHT_ACCESS',
    TestRailAccess = 'TRY_TESTRAIL_ACCESS',
    BrowserStackAccess = 'TRY_BROWSERSTACK_ACCESS',
    GoogleBetaAccess = 'TRY_GOOGLE_BETA_ACCESS',
    TravisCIAccess = 'TRY_TRAVIS_ACCESS',
    FirebaseAccess = 'TRY_CRASHLYTICS_ACCESS',
    XrayAccess = 'TRY_XRAY_ACCESS',
    QaseAccess = 'TRY_QASE_ACCESS',
    AppCenterCIAccess = 'TRY_APPCENTER_CI_ACCESS',
    AppCenterBetaAccess = 'TRY_APPCENTER_BETA_ACCESS',
    AsanaAccess = 'TRY_ASANA_ACCESS',
    ShortcutAccess = 'TRY_SHORTCUT_ACCESS',
    AmplitudeAccess = 'TRY_AMPLITUDE_ACCESS',
    AzureCIAccess = 'TRY_AZURE_CI_ACCESS',
    AzureITAccess = 'TRY_AZURE_IT_ACCESS',
    OptimizelyAccess = 'TRY_OPTIMIZELY_ACCESS',
    LaunchDarklyAccess = 'TRY_LAUNCHDARKLY_ACCESS',
    StatsigAccess = 'TRY_STATSIG_ACCESS',
    DatadogAnalyticsAccess = 'TRY_DATADOG_ANALYTICS_ACCESS',
    GenericCIAccess = 'TRY_GENERIC_CI_ACCESS',
    CustomCIAccess = 'TRY_CUSTOM_CI_ACCESS',
    MixpanelAnalyticsAccess = 'TRY_MIXPANEL_ANALYTICS_ACCESS',
    XcodeCloudAccess = 'TRY_XCODE_CLOUD_ACCESS',
    MondayAccess = 'TRY_MONDAY_ACCESS',
    FirebaseBetaAccess = 'TRY_FIREBASE_BETA_ACCESS',
    RunwayBuildDistroBetaAccess = 'TRY_RUNWAY_BUILD_DISTRO_BETA_ACCESS',
    EmbraceStabilityMonitoringAccess = 'TRY_EMBRACE_STABILITY_MONITORING_ACCESS',
    AzureVCSAccess = 'TRY_AZURE_VCS_ACCESS',
    GoogleAnalyticsAccess = 'TRY_GOOGLE_ANALYTICS_ACCESS',
    AndroidVitalsAccess = 'TRY_ANDROID_VITALS_ACCESS',
    ApplePowerPerformanceAccess = 'TRY_APPLE_POWER_PERFORMANCE_ACCESS',
    MicrosoftTeamsAccess = 'TRY_MICROSOFT_TEAMS_ACCESS',
    DatadogStabilityMonitoringAccess = 'TRY_DATADOG_STABILITY_MONITORING_ACCESS',
    CrowdinAccess = 'TRY_CROWDIN_ACCESS',
    PagerDutyAccess = 'TRY_PAGERDUTY_ACCESS',
    NewRelicStabilityMonitoringAccess = 'TRY_NEW_RELIC_STABILITY_MONITORING_ACCESS',
    NewRelicAnalyticsAccess = 'TRY_NEW_RELIC_ANALYTICS_ACCESS',
    HuaweiAppGalleryAccess = 'TRY_HUAWEI_APP_GALLERY_ACCESS',
    LokaliseAccess = 'TRY_LOKALISE_ACCESS',
    SamsungAccess = 'TRY_SAMSUNG_ACCESS',
    OpsgenieAccess = 'TRY_OPSGENIE_ACCESS',
    DynatraceAccess = 'TRY_DYNATRACE_ACCESS',
    CustomAnalyticsAccess = 'TRY_CUSTOM_ANALYTICS_ACCESS',
    GoogleCalendarAccess = 'TRY_GOOGLE_CALENDAR_ACCESS',
    GooglePersonalCalendarAccess = 'TRY_GOOGLE_PERSONAL_CALENDAR_ACCESS',
    JiraServiceManagementAccess = 'TRY_JIRA_SERVICE_MANAGEMENT_ACCESS',
    RootlyAccess = 'TRY_ROOTLY_ACCESS',
    IncidentIoAccess = 'TRY_INCIDENT_IO_ACCESS',
}

export const AllAuthUpdatableTypes = allCases(AuthUpdatable);

export enum IntegrationUpdatable {
    Slack = 'TRY_SLACK_INTEGRATION_UPDATE',
    Bitbucket = 'TRY_BITBUCKET_UPDATE',
    BitbucketCI = 'TRY_BITBUCKET_CI_UPDATE',
    GitHubVCS = 'TRY_GITHUB_VCS_INTEGRATION_UPDATE',
    GitHubVCSDist = 'TRY_GITHUB_VCS_DIST_INTEGRATION_UPDATE',
    GitHubCI = 'TRY_GITHUB_CI_INTEGRATION_UPDATE',
    GitHubIT = 'TRY_GITHUB_IT_INTEGRATION_UPDATE',
    GitHubCIDist = 'TRY_GITHUB_CI_DIST_INTEGRATION_UPDATE',
    GitLabVCS = 'TRY_GITLAB_VCS_INTEGRATION_UPDATE',
    GitLabCI = 'TRY_GITLAB_CI_INTEGRATION_UPDATE',
    Jira = 'TRY_JIRA_INTEGRATION_UPDATE',
    Pivotal = 'TRY_PIVOTAL_INTEGRATION_UPDATE',
    Codemagic = 'TRY_CODEMAGIC_INTEGRATION_UPDATE',
    Bitrise = 'TRY_BITRISE_INTEGRATION_UPDATE',
    Buildkite = 'TRY_BUILDKITE_INTEGRATION_UPDATE',
    Bugsnag = 'TRY_BUGSNAG_INTEGRATION_UPDATE',
    Sentry = 'TRY_SENTRY_INTEGRATION_UPDATE',
    AppleAppStore = 'TRY_ASC_INTEGRATION_UPDATE',
    Jenkins = 'TRY_JENKINS_INTEGRATION_UPDATE',
    Circle = 'TRY_CIRCLE_INTEGRATION_UPDATE',
    Google = 'TRY_GOOGLE_PLAY_INTEGRATION_UPDATE',
    Amazon = 'TRY_AMAZON_APP_STORE_INTEGRATION_UPDATE',
    Linear = 'TRY_LINEAR_INTEGRATION_UPDATE',
    TestFlight = 'TRY_TESTFLIGHT_INTEGRATION_UPDATE',
    TestRail = 'TRY_TESTRAIL_INTEGRATION_UPDATE',
    BrowserStack = 'TRY_BROWSERSTACK_INTEGRATION_UPDATE',
    GoogleBeta = 'TRY_GOOGLE_BETA_INTEGRATION_UPDATE',
    TravisCI = 'TRY_TRAVIS_INTEGRATION_UPDATE',
    Firebase = 'TRY_CRASHLYTICS_INTEGRATION_UPDATE',
    Xray = 'TRY_XRAY_INTEGRATION_UPDATE',
    Qase = 'TRY_QASE_INTEGRATION_UPDATE',
    AppCenterCI = 'TRY_APPCENTER_CI_INTEGRATION_UPDATE',
    AppCenterBeta = 'TRY_APPCENTER_BETA_INTEGRATION_UPDATE',
    Asana = 'TRY_ASANA_INTEGRATION_UPDATE',
    Shortcut = 'TRY_SHORTCUT_INTEGRATION_UPDATE',
    Amplitude = 'TRY_AMPLITUDE_INTEGRATION_UPDATE',
    AzureCI = 'TRY_AZURE_CI_INTEGRATION_UPDATE',
    AzureIT = 'TRY_AZURE_IT_INTEGRATION_UPDATE',
    Optimizely = 'TRY_OPTIMIZELY_INTEGRATION_UPDATE',
    LaunchDarkly = 'TRY_LAUNCHDARKLY_INTEGRATION_UPDATE',
    Statsig = 'TRY_STATSIG_INTEGRATION_UPDATE',
    DatadogAnalytics = 'TRY_DATADOG_ANALYTICS_INTEGRATION_UPDATE',
    GenericCI = 'TRY_GENERIC_CI_INTEGRATION_UPDATE',
    CustomCI = 'TRY_CUSTOM_CI_INTEGRATION_UPDATE',
    MixpanelAnalytics = 'TRY_MIXPANEL_ANALYTICS_INTEGRATION_UPDATE',
    XcodeCloud = 'TRY_XCODE_CLOUD_INTEGRATION_UPDATE',
    Monday = 'TRY_MONDAY_INTEGRATION_UPDATE',
    FirebaseBeta = 'TRY_FIREBASE_BETA_INTEGRATION_UPDATE',
    RunwayBuildDistroBeta = 'TRY_RUNWAY_BUILD_DISTRO_BETA_INTEGRATION_UPDATE',
    EmbraceStabilityMonitoring = 'TRY_EMBRACE_STABILITY_MONITORING_UPDATE',
    AzureVCS = 'TRY_AZURE_VCS_UPDATE',
    GoogleAnalytics = 'TRY_GOOGLE_ANALYTICS_UPDATE',
    AndroidVitals = 'TRY_ANDROID_VITALS_UPDATE',
    ApplePowerPerformance = 'TRY_APPLE_POWER_PERFORMANCE_UPDATE',
    MicrosoftTeams = 'TRY_MICROSOFT_TEAMS_UPDATE',
    DatadogStabilityMonitoring = 'TRY_DATADOG_STABILITY_MONITORING_UPDATE',
    Dynatrace = 'TRY_DYNATRACE_UPDATE',
    Crowdin = 'TRY_CROWDIN_UPDATE',
    PagerDutyScheduling = 'TRY_PAGERDUTY_SCHEDULING_UPDATE',
    NewRelicStabilityMonitoring = 'TRY_NEW_RELIC_STABILITY_MONITORING_UPDATE',
    NewRelicAnalytics = 'TRY_NEW_RELIC_ANALYTICS_UPDATE',
    HuaweiAppGallery = 'TRY_HUAWEI_UPDATE',
    Lokalise = 'TRY_LOKALISE_UPDATE',
    Samsung = 'TRY_SAMSUNG_UPDATE',
    OpsgenieScheduling = 'TRY_OPSGENIE_SCHEDULING_UPDATE',
    CustomAnalytics = 'TRY_CUSTOM_ANALYTICS_UPDATE',
    GoogleCalendar = 'TRY_GOOGLE_CALENDAR_UPDATE',
    GooglePersonalCalendar = 'TRY_GOOGLE_PERSONAL_CALENDAR_UPDATE',
    JiraServiceManagement = 'TRY_JIRA_SERVICE_MANAGEMENT_UPDATE',
    RootlyScheduling = 'TRY_ROOTLY_SCHEDULING_UPDATE',
    IncidentIoScheduling = 'TRY_INCIDENT_IO_SCHEDULING_UPDATE',
}

export const AllIntegrationUpdatableTypes = allCases(IntegrationUpdatable);

export enum IntegrationRefreshable {
    Slack = 'TRY_SLACK_INTEGRATION_REFRESH',
    Bitbucket = 'TRY_BITBUCKET_REFRESH',
    BitbucketCI = 'TRY_BITBUCKET_CI_REFRESH',
    GitHubVCS = 'TRY_GITHUB_VCS_INTEGRATION_REFRESH',
    GitHubVCSDist = 'TRY_GITHUB_VCS_DIST_INTEGRATION_REFRESH',
    GitHubCI = 'TRY_GITHUB_CI_INTEGRATION_REFRESH',
    GitHubIT = 'TRY_GITHUB_IT_INTEGRATION_REFRESH',
    GitHubCIDist = 'TRY_GITHUB_CI_DIST_INTEGRATION_REFRESH',
    GitLabVCS = 'TRY_GITLAB_VCS_INTEGRATION_REFRESH',
    GitLabCI = 'TRY_GITLAB_CI_INTEGRATION_REFRESH',
    Jira = 'TRY_JIRA_INTEGRATION_REFRESH',
    Pivotal = 'TRY_PIVOTAL_INTEGRATION_REFRESH',
    Codemagic = 'TRY_CODEMAGIC_INTEGRATION_REFRESH',
    Bitrise = 'TRY_BITRISE_INTEGRATION_REFRESH',
    Buildkite = 'TRY_BUILDKITE_INTEGRATION_REFRESH',
    Bugsnag = 'TRY_BUGSNAG_INTEGRATION_REFRESH',
    Sentry = 'TRY_SENTRY_INTEGRATION_REFRESH',
    AppleAppStore = 'TRY_ASC_INTEGRATION_REFRESH',
    Jenkins = 'TRY_JENKINS_INTEGRATION_REFRESH',
    Circle = 'TRY_CIRCLE_INTEGRATION_REFRESH',
    Google = 'TRY_GOOGLE_PLAY_INTEGRATION_REFRESH',
    Amazon = 'TRY_AMAZON_APP_STORE_INTEGRATION_REFRESH',
    Linear = 'TRY_LINEAR_INTEGRATION_REFRESH',
    TestFlight = 'TRY_TESTFLIGHT_INTEGRATION_REFRESH',
    TestRail = 'TRY_TESTRAIL_INTEGRATION_REFRESH',
    BrowserStack = 'TRY_BROWSERSTACK_INTEGRATION_REFRESH',
    GoogleBeta = 'TRY_GOOGLE_BETA_INTEGRATION_REFRESH',
    TravisCI = 'TRY_TRAVIS_INTEGRATION_REFRESH',
    Firebase = 'TRY_CRASHLYTICS_INTEGRATION_REFRESH',
    Xray = 'TRY_XRAY_INTEGRATION_REFRESH',
    Qase = 'TRY_QASE_INTEGRATION_REFRESH',
    AppCenterCI = 'TRY_APPCENTER_CI_INTEGRATION_REFRESH',
    AppCenterBeta = 'TRY_APPCENTER_BETA_INTEGRATION_REFRESH',
    Asana = 'TRY_ASANA_INTEGRATION_REFRESH',
    Shortcut = 'TRY_SHORTCUT_INTEGRATION_REFRESH',
    Amplitude = 'TRY_AMPLITUDE_INTEGRATION_REFRESH',
    AzureCI = 'TRY_AZURE_CI_INTEGRATION_REFRESH',
    AzureIT = 'TRY_AZURE_IT_INTEGRATION_REFRESH',
    Optimizely = 'TRY_OPTIMIZELY_INTEGRATION_REFRESH',
    LaunchDarkly = 'TRY_LAUNCHDARKLY_INTEGRATION_REFRESH',
    Statsig = 'TRY_STATSIG_INTEGRATION_REFRESH',
    DatadogAnalytics = 'TRY_DATADOG_ANALYTICS_INTEGRATION_REFRESH',
    GenericCI = 'TRY_GENERIC_CI_INTEGRATION_REFRESH',
    CustomCI = 'TRY_CUSTOM_CI_INTEGRATION_REFRESH',
    MixpanelAnalytics = 'TRY_MIXPANEL_ANALYTICS_INTEGRATION_REFRESH',
    XcodeCloud = 'TRY_XCODE_CLOUD_INTEGRATION_REFRESH',
    Monday = 'TRY_MONDAY_INTEGRATION_REFRESH',
    FirebaseBeta = 'TRY_FIREBASE_BETA_INTEGRATION_REFRESH',
    RunwayBuildDistroBeta = 'TRY_RUNWAY_BUILD_DISTRO_BETA_INTEGRATION_REFRESH',
    EmbraceStabilityMonitoring = 'TRY_EMBRACE_STABILITY_MONITORING_REFRESH',
    AzureVCS = 'TRY_AZURE_VCS_REFRESH',
    GoogleAnalytics = 'TRY_GOOGLE_ANALYTICS_REFRESH',
    ApplePowerPerformance = 'TRY_APPLE_POWER_PERFORMANCE_REFRESH',
    MicrosoftTeams = 'TRY_MICROSOFT_TEAMS_REFRESH',
    DatadogStabilityMonitoring = 'TRY_DATADOG_STABILITY_MONITORING_REFRESH',
    Dynatrace = 'TRY_DYNATRACE_REFRESH',
    Crowdin = 'TRY_CROWDIN_REFRESH',
    PagerDutyScheduling = 'TRY_PAGERDUTY_SCHEDULING_REFRESH',
    NewRelicStabilityMonitoring = 'TRY_NEW_RELIC_STABILITY_MONITORING_REFRESH',
    NewRelicAnalytics = 'TRY_NEW_RELIC_ANALYTICS_REFRESH',
    HuaweiAppGallery = 'TRY_HUAWEI_REFRESH',
    Lokalise = 'TRY_LOKALISE_REFRESH',
    Samsung = 'TRY_SAMSUNG_REFRESH',
    OpsgenieScheduling = 'TRY_OPSGENIE_SCHEDULING_REFRESH',
    CustomAnalytics = 'TRY_CUSTOM_ANALYTICS_REFRESH',
    JiraServiceManagement = 'TRY_JIRA_SERVICE_MANAGEMENT_REFRESH',
    RootlyScheduling = 'TRY_ROOTLY_SCHEDULING_REFRESH',
    IncidentIoScheduling = 'TRY_INCIDENT_IO_SCHEDULING_REFRESH',
}

export const AllIntegrationRefreshableTypes = allCases(IntegrationRefreshable);

export enum IntegrationDeletable {
    Slack = 'TRY_SLACK_INTEGRATION_DELETE',
    Bitbucket = 'TRY_BITBUCKET_DELETE',
    BitbucketCI = 'TRY_BITBUCKET_CI_DELETE',
    GitHubVCS = 'TRY_GITHUB_VCS_INTEGRATION_DELETE',
    GitHubVCSDist = 'TRY_GITHUB_VCS_DIST_INTEGRATION_DELETE',
    GitHubCI = 'TRY_GITHUB_CI_INTEGRATION_DELETE',
    GitHubIT = 'TRY_GITHUB_IT_INTEGRATION_DELETE',
    GitHubCIDist = 'TRY_GITHUB_CI_DIST_INTEGRATION_DELETE',
    GitLabVCS = 'TRY_GITLAB_VCS_INTEGRATION_DELETE',
    GitLabCI = 'TRY_GITLAB_CI_INTEGRATION_DELETE',
    Jira = 'TRY_JIRA_INTEGRATION_DELETE',
    Pivotal = 'TRY_PIVOTAL_INTEGRATION_DELETE',
    Codemagic = 'TRY_CODEMAGIC_INTEGRATION_DELETE',
    Bitrise = 'TRY_BITRISE_INTEGRATION_DELETE',
    Buildkite = 'TRY_BUILDKITE_INTEGRATION_DELETE',
    Bugsnag = 'TRY_BUGSNAG_INTEGRATION_DELETE',
    Sentry = 'TRY_SENTRY_INTEGRATION_DELETE',
    AppleAppStore = 'TRY_ASC_INTEGRATION_DELETE',
    Jenkins = 'TRY_JENKINS_INTEGRATION_DELETE',
    Circle = 'TRY_CIRCLE_INTEGRATION_DELETE',
    Google = 'TRY_GOOGLE_PLAY_INTEGRATION_DELETE',
    Amazon = 'TRY_AMAZON_APP_STORE_INTEGRATION_DELETE',
    Linear = 'TRY_LINEAR_INTEGRATION_DELETE',
    TestFlight = 'TRY_TESTFLIGHT_INTEGRATION_DELETE',
    TestRail = 'TRY_TESTRAIL_INTEGRATION_DELETE',
    BrowserStack = 'TRY_BROWSERSTACK_INTEGRATION_DELETE',
    GoogleBeta = 'TRY_GOOGLE_BETA_INTEGRATION_DELETE',
    TravisCI = 'TRY_TRAVIS_INTEGRATION_DELETE',
    Firebase = 'TRY_CRASHLYTICS_INTEGRATION_DELETE',
    Xray = 'TRY_XRAY_INTEGRATION_DELETE',
    Qase = 'TRY_QASE_INTEGRATION_DELETE',
    AppCenterCI = 'TRY_APPCENTER_CI_INTEGRATION_DELETE',
    AppCenterBeta = 'TRY_APPCENTER_BETA_INTEGRATION_DELETE',
    Asana = 'TRY_ASANA_INTEGRATION_DELETE',
    Shortcut = 'TRY_SHORTCUT_INTEGRATION_DELETE',
    Amplitude = 'TRY_AMPLITUDE_INTEGRATION_DELETE',
    AzureCI = 'TRY_AZURE_CI_INTEGRATION_DELETE',
    AzureIT = 'TRY_AZURE_IT_INTEGRATION_DELETE',
    Optimizely = 'TRY_OPTIMIZELY_INTEGRATION_DELETE',
    LaunchDarkly = 'TRY_LAUNCHDARKLY_INTEGRATION_DELETE',
    Statsig = 'TRY_STATSIG_INTEGRATION_DELETE',
    DatadogAnalytics = 'TRY_DATADOG_ANALYTICS_INTEGRATION_DELETE',
    GenericCI = 'TRY_GENERIC_CI_INTEGRATION_DELETE',
    CustomCI = 'TRY_CUSTOM_CI_INTEGRATION_DELETE',
    MixpanelAnalytics = 'TRY_MIXPANEL_ANALYTICS_INTEGRATION_DELETE',
    XcodeCloud = 'TRY_XCODE_CLOUD_INTEGRATION_DELETE',
    Monday = 'TRY_MONDAY_INTEGRATION_DELETE',
    FirebaseBeta = 'TRY_FIREBASE_BETA_INTEGRATION_DELETE',
    RunwayBuildDistroBeta = 'TRY_RUNWAY_BUILD_DISTRO_BETA_INTEGRATION_DELETE',
    EmbraceStabilityMonitoring = 'TRY_EMBRACE_STABILITY_MONITORING_DELETE',
    AzureVCS = 'TRY_AZURE_VCS_DELETE',
    GoogleAnalytics = 'TRY_GOOGLE_ANALYTICS_DELETE',
    AndroidVitals = 'TRY_ANDROID_VITALS_DELETE',
    ApplePowerPerformance = 'TRY_APPLE_POWER_PERFORMANCE_DELETE',
    MicrosoftTeams = 'TRY_MICROSOFT_TEAMS_DELETE',
    DatadogStabilityMonitoring = 'TRY_DATADOG_STABILITY_MONITORING_DELETE',
    Crowdin = 'TRY_CROWDIN_DELETE',
    PagerDutyScheduling = 'TRY_PAGERDUTY_SCHEDULING_DELETE',
    NewRelicStabilityMonitoring = 'TRY_NEW_RELIC_STABILITY_MONITORING_DELETE',
    NewRelicAnalytics = 'TRY_NEW_RELIC_ANALYTICS_DELETE',
    HuaweiAppGallery = 'TRY_HUAWEI_DELETE',
    Lokalise = 'TRY_LOKALISE_DELETE',
    Samsung = 'TRY_SAMSUNG_DELETE',
    OpsgenieScheduling = 'TRY_OPSGENIE_SCHEDULING_DELETE',
    Dynatrace = 'TRY_DYNATRACE_DELETE',
    CustomAnalytics = 'TRY_CUSTOM_ANALYTICS_DELETE',
    GoogleCalendar = 'TRY_GOOGLE_CALENDAR_DELETE',
    GooglePersonalCalendar = 'TRY_GOOGLE_PERSONAL_CALENDAR_DELETE',
    JiraServiceManagement = 'TRY_JIRA_SERVICE_MANAGEMENT_DELETE',
    RootlyScheduling = 'TRY_ROOTLY_SCHEDULING_DELETE',
    IncidentIoScheduling = 'TRY_INCIDENT_IO_SCHEDULING_DELETE',
}

export const AllIntegrationDeletableTypes = allCases(IntegrationDeletable);

export enum BuildDistributionUpdatable {
    // TODO: more to come...
    AddBuildDistroBucketMembers = 'TRY_ADD_BUILD_DISTRO_BUCKET_MEMBERS',
    RemoveBuildDistroBucketMember = 'TRY_REMOVE_BUILD_DISTRO_BUCKET_MEMBER',
    UpdateBuildDistroBucketMemberPermissions = 'TRY_UPDATE_BUILD_DISTRO_BUCKET_MEMBER_PERMISSIONS',
    ToggleBuildDistroBucketNotifications = 'TRY_TOGGLE_BUILD_DISTRO_BUCKET_NOTIFICATION',
    UpdateBuildDistroBucketNotificationSettings = 'TRY_UPDATE_BUILD_DISTRO_BUCKET_NOTIFICATION_SETTINGS',
    UpdateBuildDistroBucketAutomationSettings = 'TRY_UPDATE_BUILD_DISTRO_BUCKET_AUTOMATION_SETTINGS',
    UpdateBuildDistroBucket = 'TRY_UPDATE_BUILD_DISTRO_BUCKET',
}

export const AllBuildDistroUpdatableTypes = allCases(BuildDistributionUpdatable);

export type Updatable =
    | ReleaseUpdatable
    | AppSettingsUpdatable
    | AuthUpdatable
    | IntegrationUpdatable
    | IntegrationDeletable
    | BuildDistributionUpdatable
    | DestinationUpdatable
    | PublicApiUpdatable
    | UserUpdatable;

export enum UserUpdatable {
    CREATE_USER = 'CREATE_USER',
    CREATE_USER_SUCCESS = 'CREATE_USER_SUCCESS',
    CREATE_USER_FAILURE = 'CREATE_USER_FAILURE',
    TRY_SIGN_UP = 'TRY_SIGN_UP',
    TRY_NEW_PASSWORD = 'TRY_NEW_PASSWORD',
    NEW_PASSWORD_SUCCESS = 'NEW_PASSWORD_SUCCESS',
    NEW_PASSWORD_FAILURE = 'NEW_PASSWORD_FAILURE',
    UPDATE_USER_DEVICES = 'UPDATE_USER_DEVICES',
    UPDATE_USER_DEVICES_SUCCESS = 'UPDATE_USER_DEVICES_SUCCESS',
    UPDATE_USER_EMAIL_NOTIFICATION_SETTINGS = 'UPDATE_USER_EMAIL_NOTIFICATION_SETTINGS',
    UPDATE_SHOW_SIMPLIFIED_BD_UI = 'UPDATE_SHOW_SIMPLIFIED_BD_UI',
    UPDATE_SHOW_SIMPLIFIED_BD_UI_SUCCESS = 'UPDATE_SHOW_SIMPLIFIED_BD_UI_SUCCESS',
    UPDATE_TIMEZONE_PREFERENCE_SUCCESS = 'UPDATE_TIMEZONE_PREFERENCE_SUCCESS',
    UPDATE_EMAIL_NOTIFICATIONS_SUCCESS = 'UPDATE_EMAIL_NOTIFICATIONS_SUCCESS',
    VERIFY_COMMS_USER = 'VERIFY_COMMS_USER',
    VERIFY_COMMS_USER_SUCCESS = 'VERIFY_COMMS_USER_SUCCESS',
    VERIFY_COMMS_USER_FAILURE = 'VERIFY_COMMS_USER_FAILURE',
}

export const AllUserUpdatableTypes = allCases(UserUpdatable);

export enum DevicesUpdatable {
    RegisterDevices = 'TRY_REGISTER_DEVICES',
    DisableEnableDevices = 'TRY_DISABLE_ENABLE_DEVICES',
    DeleteDevices = 'TRY_DELETE_DEVICES',
    AddDevice = 'TRY_ADD_DEVICE',
}

export const AllDevicesUpdatableTypes = allCases(DevicesUpdatable);
